// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['hi_IN'] /*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

 = {
  name: 'hi_IN',
  day: {
    abbrev: ['रवि ', 'सोम ', 'मंगल ', 'बुध ', 'गुरु ', 'शुक्र ', 'शनि '],
    full: ['रविवार ', 'सोमवार ', 'मंगलवार ', 'बुधवार ', 'गुरुवार ', 'शुक्रवार ', 'शनिवार '],
  },
  month: {
    abbrev: [
      'जनवरी',
      'फ़रवरी',
      'मार्च',
      'अप्रेल',
      'मई',
      'जून',
      'जुलाई',
      'अगस्त',
      'सितम्बर',
      'अक्टूबर',
      'नवम्बर',
      'दिसम्बर',
    ],
    full: [
      'जनवरी',
      'फ़रवरी',
      'मार्च',
      'अप्रेल',
      'मई',
      'जून',
      'जुलाई',
      'अगस्त',
      'सितम्बर',
      'अक्टूबर',
      'नवम्बर',
      'दिसम्बर',
    ],
  },
  meridiem: ['पूर्वाह्न', 'अपराह्न'],
  date: '%A %d %b %Y',
  time24: '%I:%M:%S  %Z',
  dateTime: '%A %d %b %Y %I:%M:%S %p %Z',
  time12: '%I:%M:%S %p %Z',
  full: '%a %b %e %H:%M:%S %Z %Y',
}

